module.exports = __webpack_public_path__ + "icomoon.svg?d5dd270ea05b4b734a97c2dd021856b9";